import { actions } from './reducer';
class Dispatch {
    constructor() {
        this.actions = actions;
    }
}
const SettingsDispatcher = new Dispatch();
export default SettingsDispatcher;
